import { FromJSONable } from "../../model/FromJSONable";

export interface RegimesResponse {
  regimes: Regime[];
}
export interface Regime {
  id: number;
  clave: string;
  descripcion: string;
  aplicaPersonaFisica: string;
  aplicaPersonaMoral: string;
  Exception: null;
}
export interface CFDI {
  codigo: string;
  descripcion: string;
}
export interface InvoiceRequest {
  claveVenta: string;
  rfc: string;
  razonSocial: string;
  calle: string;
  numeroInt: string;
  numeroExt: string;
  codigoPostal: string;
  coloniaCod: string;
  coloniaDesc: string;
  municipioCod: string;
  municipioDesc: string;
  localidadCod: string;
  localidadDesc: string;
  estadoCod: string;
  estadoDesc: string;
  paisCod: string;
  paisDesc: string;
  regfiscalCod: string;
  regfiscalDesc: string;
  usoCfdi: string;
  usoCfdiDesc: string;
  correoElectronico: string;
  telefono: string;
}
export class RegimesClass implements RegimesResponse, FromJSONable {
  constructor() {}
  parseJSONObject(object: Object) {
    Object.assign(this.regimes, object);
  }
  regimes: Regime[] = [];
}
export class CFDIClass implements FromJSONable {
  constructor() {}
  cfdis: CFDI[] = [];
  parseJSONObject(object: Object) {
    Object.assign(this.cfdis, object);
  }
}
